import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Dropdown } from 'semantic-ui-react'
import { ThemeContext } from 'styled-components'
import i18n from '~/components/i18n'
import { StyledFiltersOptions } from '../../Reporting/TradingActivities/style'

export const getFeedPurchaseFilterKeys = () => [
  {
    key: 'creationDate',
    label: i18n.t('Creation date'),
    fromKey: 'createdAtFrom',
    toKey: 'createdAtTo',
    fromPlaceholder: i18n.t('Creation date from'),
    toPlaceholder: i18n.t('Creation date to')
  },
  {
    key: 'purchaseDate',
    label: i18n.t('Purchase date'),
    fromKey: 'purchaseDateFrom',
    toKey: 'purchaseDateTo',
    fromPlaceholder: i18n.t('Purchase date from'),
    toPlaceholder: i18n.t('Purchase date to')
  },
  {
    key: 'feeding',
    label: i18n.t('Feeding'),
    fromKey: 'feedingFrom',
    toKey: 'feedingTo',
    fromPlaceholder: i18n.t('Feeding from'),
    toPlaceholder: i18n.t('Feeding to')
  }
]

interface Props {
  checkedFilters: any[]
  handleCheckFilter: (checked: boolean, filter: any) => void
}

const FilterDropdown: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { firstColor } = useContext(ThemeContext)

  const { checkedFilters, handleCheckFilter } = props

  const filters = getFeedPurchaseFilterKeys()

  return <StyledFiltersOptions
    text={t('Filters')}
    icon='filter'
    floating
    labeled
    button
    closeOnChange={false}
    multiple
    className='icon'
    style={{ background: firstColor, color: 'white' }}
  >
    <Dropdown.Menu>
      <Dropdown.Menu scrolling style={{ overflowY: 'hidden', minHeight: 'max-content' }}>
        {filters.map((filter) => {
          const checked = Boolean(checkedFilters.find(filterChecked => filterChecked.key === filter.key))
          return <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              handleCheckFilter(!checked, filter)
            }}
            key={filter.key}
          >
            <Checkbox
              checked={checked}
              label={filter.label}
            />
          </Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown.Menu>
  </StyledFiltersOptions>
}
export default FilterDropdown
